import React, {useEffect, useState} from 'react';
import './search.scss';
import {CriteriaConfig} from '../../../../../dtos/search-criteria.dto';
import CustomButton from '../../../../shared/custom-button/custom-button';
import {CriteriaList} from '../../../../shared/criteria-list/criteria-list';
import usePromiseFeedback from '../../../../shared/promise-feedback/usePromiseFeedback';
import {useDebouncedValidation} from '../../../../shared/hooks/debounced-validation-hook';
import {validateValue} from '../../../../../utils/validationUtils';

interface SearchProps<T> {
    criteriaConfig: CriteriaConfig<T>[];
    show: boolean;
    hasPermissions?: boolean;
    currentSearchCriteria: T;
    setSearchCriteria: (searchCriteria: T) => void;
    onSearch: () => Promise<void>;
    isLoading: boolean;
}

export const Search = <T, >({
                                                           criteriaConfig,
                                                           show,
                                                           currentSearchCriteria,
                                                           setSearchCriteria,
                                                           onSearch,
                                                           hasPermissions = true,
                                                           isLoading
                                                       }: SearchProps<T>) => {
    const [validationErrors, setValidationErrors] = useState<Map<string, string>>(new Map());
    const debouncedValidateInput = useDebouncedValidation(criteriaConfig, setValidationErrors);
    const [promiseFeedbackFactory, promiseContextHolder] = usePromiseFeedback();

    useEffect(() => {
        (Object.keys(currentSearchCriteria as any)).forEach(key => {
            const column = criteriaConfig.find((col) => col.accessor === key);
            return validateValue(column, setValidationErrors, key, (currentSearchCriteria as any)[key]);
        });
    },[]);

    const handleSearch = () => {
        promiseFeedbackFactory({
            promise: onSearch(),
            notifObj: {show: false}
        });
    };

    const changeSearchCriteria = (searchCriteria: T, accessor: keyof T) => {
        setSearchCriteria(searchCriteria);
        debouncedValidateInput(accessor, (searchCriteria as any)[accessor]);
    };

    return <div className={`expanded-search flex ${show ? 'open' : 'close'}`}>
        <div className="search-content">
            <CriteriaList criteriaConfig={criteriaConfig}
                          validationErrors={validationErrors}
                          searchCriteria={currentSearchCriteria}
                          changeSearchCriteria={changeSearchCriteria} />
        </div>
        <div className="actions flex">
            <CustomButton label={'Search'} className="primary-btn" onClick={handleSearch}
                          isDisabled={!hasPermissions || validationErrors.size > 0 || isLoading} />
        </div>
        {promiseContextHolder}
    </div>;
};